module.exports = __webpack_public_path__ + "786177b38a10be012bfe561b3e9b2e45.svg";